module.exports = __webpack_public_path__ + "media/images/categoryIcons/security_tank-6cfab1c17ef6fb1a82423fcdaae7694f.svg";